var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyanmar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5652C31.648 19.8319 32 17.9571 32 16C32 14.0428 31.648 12.168 31.0048 10.4348L16 9.04346L0.995188 10.4348C0.352063 12.168 0 14.0428 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.9565L31.0048 21.5652Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.004 10.4348C28.7433 4.342 22.8786 0 15.9992 0C9.11976 0 3.25507 4.342 0.994385 10.4348H31.004Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 32C22.8786 32 28.7433 27.658 31.004 21.5652H0.994385C3.25507 27.658 9.11976 32 15.9992 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9717 13.5366H18.59L15.9999 5.56519L13.4098 13.5366H5.02808L11.809 18.4632L9.21889 26.4348L15.9999 21.5652L22.7809 26.4347L20.1908 18.4632L26.9717 13.5366Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyanmar);
export default __webpack_public_path__ + "static/media/myanmar.0fb6e074.svg";
export { ForwardRef as ReactComponent };